export function request(postCode) {
    return {
        type: 'POSTCODE_FIND_REQUEST',
        postCode
    };
}

export function error(postCode, errors) {
    return {
        type: 'POSTCODE_FIND_ERROR',
        postCode,
        errors
    };
}

export function finish(postCode, results) {
    return {
        type: 'POSTCODE_FIND_FINISH',
        postCode,
        results
    };
}

export function clear() {
    return {
        type: 'POSTCODE_FIND_CLEAR'
    };
}
